import {handleRequest} from './base/handleRequest'
import {RequestMethod} from '../../model/enums/enums'
import {SignedUrlResponse} from '../../model/signedUrlResponse.model'
import {State} from '../../model/state.model'

export const handleFileUpload = (props: {
	handleUploadResult: (documentId: (number | undefined)) => void
	uploadUrl: string | undefined
	documentId: number | undefined
}) => {
	return async (event: any) => {
		const fileId = props.documentId

		if (!fileId) {
			console.error('Document Id is missing.')
			return undefined
		}

		const fileToUpload = event.files?.[0] // get the first

		if (!props.uploadUrl) {
			console.error('Upload URL is missing.')
			return undefined
		}

		if (!fileToUpload) {
			console.warn('File to upload is missing.')
			// todo show validation error
			return undefined
		}

		if (fileToUpload.type !== 'application/pdf') {
			console.warn('Filetype is not pdf! Will not upload.')
			// todo show error
			return -1
		}

		// get the signed url
		const result: State<SignedUrlResponse> =
			await handleRequest<SignedUrlResponse>(props.uploadUrl, RequestMethod.POST)
		if (result.error) {
			console.error(result.error)
			return undefined
		}

		const signedUrl = result?.data?.url
		if (!signedUrl) {
			console.error('signed url is not provided')
			return undefined
		}

		const uploadResult = await handleRequest<any>(signedUrl, RequestMethod.UPLOAD, fileToUpload, undefined, true)

		if (uploadResult.error) {
			console.error(uploadResult)
			//TODO handle error
			return undefined
		}

		props.handleUploadResult(fileId)
		return fileId
	}
}



export const handleFileUploadByFile = (props: {
	handleUploadResult: (documentId: (number | undefined)) => void
	uploadUrl: string | undefined
	documentId: number | undefined
}) => {
	return async (file: File) => {
		const fileId = props.documentId

		if (!fileId) {
			console.error('Document Id is missing.')
			return undefined
		}

		const fileToUpload = file // get the first

		if (!props.uploadUrl) {
			console.error('Upload URL is missing.')
			return undefined
		}

		if (!fileToUpload) {
			console.warn('File to upload is missing.')
			// todo show validation error
			return undefined
		}

		if (fileToUpload.type !== 'application/pdf') {
			console.warn('Filetype is not pdf! Will not upload.')
			// todo show error
			return -1
		}

		// get the signed url
		const result: State<SignedUrlResponse> =
			await handleRequest<SignedUrlResponse>(props.uploadUrl, RequestMethod.POST)
		if (result.error) {
			console.error(result.error)
			return undefined
		}

		const signedUrl = result?.data?.url
		if (!signedUrl) {
			console.error('signed url is not provided')
			return undefined
		}

		const uploadResult = await handleRequest<any>(signedUrl, RequestMethod.UPLOAD, fileToUpload, undefined, true)

		if (uploadResult.error) {
			console.error(uploadResult)
			//TODO handle error
			return undefined
		}

		props.handleUploadResult(fileId)
		return fileId
	}
}